import { render } from "./PreviousLecture.vue?vue&type=template&id=57663a06&scoped=true"
import script from "./PreviousLecture.vue?vue&type=script&lang=js"
export * from "./PreviousLecture.vue?vue&type=script&lang=js"

import "./PreviousLecture.vue?vue&type=style&index=0&id=57663a06&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57663a06"]])

export default __exports__